module.exports = __webpack_public_path__ + "static/media/MSW_05.b3211065.jpg";